import { BASE_URL } from "../constants/constants";
import { EmployeeModel } from "../model/EmployeeModel";
import AuthUtils from "../auth/AuthUtils";
export class EmployeeService {
  public async addEmployee(employmentModel: EmployeeModel) {
    let jsonBody = JSON.stringify(employmentModel);
    try {
      let response = await fetch(`${BASE_URL}/employees/add`, {
        method: "POST",
        headers: AuthUtils.getHeaders(),
        body: jsonBody,
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async editEmployee(employmentModel: EmployeeModel) {
    let jsonBody = JSON.stringify(employmentModel);
    try {
      let response = await fetch(
        `${BASE_URL}/employees/${employmentModel._id}`, //`${BASE_URL}/employees/update/${employmentModel._id}`,
        {
          method: "POST",
          headers: AuthUtils.getHeaders(),
          body: jsonBody,
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async deleteEmployee(employmentModel: EmployeeModel) {
    try {
      let response = await fetch(
        `${BASE_URL}/employees/${employmentModel._id}`, //`${BASE_URL}/employees/update/${employmentModel._id}`,
        {
          method: "DELETE",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async deleteAllSelectedEmployees(selectedList: any) {
    try {
      let response = await fetch(
        `${BASE_URL}/employees/delete/multiple`,
        {
          method: "DELETE",
          headers: AuthUtils.getHeaders(),
          body: JSON.stringify(selectedList),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async getEmployeesByCompanyId(companyId: String) {
    try {
      let response = await fetch(
        `${BASE_URL}/employees/companies/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public getEmployeesByCompanyIdAsync(
    companyId: String,
    onSuccess: any,
    onFailure: any
  ) {
    try {
      fetch(`${BASE_URL}/employees/companies/${companyId}`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      }).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e:any) {
      onFailure(e);
    }
  }

  public async getActionedInspectionsByCompany(
    companyId: String,
    employeeId: String
  ) {
    try {
      let response = await fetch(
        `${BASE_URL}/employees/actioned/${employeeId}/companies/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async importEmployees(companyId: String, data: any) {
    var encodedString = btoa(data);
    try {
      let response = await fetch(
        `${BASE_URL}/employees/import/companies/${companyId}`,
        {
          method: "POST",
          headers: AuthUtils.getHeaders(),
          body: JSON.stringify({ file: encodedString }),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async getCompanyDetails(companyId: String) {
    try {
      let response = await fetch(`${BASE_URL}/companies/${companyId}`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
  public async getCompanyDetailsAsync(
    companyId: String,
    onSuccess: any,
    onFailure: any
  ) {
    try {
      fetch(`${BASE_URL}/companies/${companyId}`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      }).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e:any) {
      onFailure(e);
    }
  }
}
